import { Option } from 'components/interfaces/GeneralInterface';
import { OrganisationUnitApiInterface } from 'submodules/api_middleware';

export const getOrganizationUnitSelectValues = (
    organisationUnits: OrganisationUnitApiInterface[]
): Option[] =>
    organisationUnits?.map((unit: OrganisationUnitApiInterface) => ({
        value: unit.id,
        label: unit.name,
    })) || [];
